/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */
const divorceForFreeSectionStyle = (theme) => ({
  sectionHeadline: {
    color: theme.palette.primary.main,
  },
  container: {
    backgroundColor: theme.palette.background.contrast,
    textAlign: "center",
  },
});

export default divorceForFreeSectionStyle;
